import React, { useContext } from 'react';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SisuActionPopover from '../../../../../ActionBar/_partials/SisuActionPopover/SisuActionPopover';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentForAnonymous from '../../../../../CommentForAnonymous';

interface Props {}

const AnonymousView: React.FC<Props> = () => {
  const isMobile = useContext(MobileContext);
  const isSisuPopoverEnabled = useFlag('sisu_popover');

  const content = isSisuPopoverEnabled ? (
    <SisuActionPopover restrictedActionName={ReferralType.COMMENT_ACTION}>
      <CommentForAnonymous asSisuPopoverTrigger />
    </SisuActionPopover>
  ) : (
    <CommentForAnonymous />
  );

  return (
    <CommentBoxLayout
      avatar={!isMobile && <CommentBoxAvatar withLink={false} />}
      content={content}
    />
  );
};
AnonymousView.displayName = 'AnonymousView';

export default AnonymousView;
